import { api } from './request'

const requestApi = {
  queryUserListSelect: `/common/queryUserListSelect`, // 查询成员列表选择框
  queryOrderList: `/order/queryOrderList`, // 查询订单列表
  queryShipListSelect: `/common/queryShipListSelect`, // 查询船名列表选择框
  queryShipOwnerListSelect: `/common/queryShipOwnerListSelect`, // 查询船主列表选择框
  queryCargoOwnerListSelect: `/common/queryCargoOwnerListSelect`, // 查询货主列表选择框
  queryGoodsData: `/basicData/queryGoodsData`, // 查询货名字典
  getHCBatchNo: `/order/getHCBatchNo`, // 获取航次编号
  createOrder: `/order/createOrder`, // 新建订单

  queryOrderInfo: `/order/queryOrderInfo`, // 查询订单信息
  changeOrderStatus: `/order/changeOrderStatus`, // 修改订单状态
  updateStatusChange: `/order/updateStatusChange`, // 修改订单状态2.1.1
  // 合同
  queryOrderInfoContract: `/order/queryOrderInfoContract`, // 查询订单合同
  saveOrderInfoContract: `/order/saveOrderInfoContract`, // 保存合同
  // 监管
  getOrderSupervisionInfo: `/supervision/getOrderSupervisionInfo`, // 订单装卸信息
  getGoodsReleaseDetail: `/supervision/getGoodsReleaseDetail`, // 获取放货指令详情
  applyLoadTask: `/supervision/applyLoadTask`, // 申请监装
  addGoodsDetail: `/supervision/addGoodsDetail`, // 新增装卸货明细
  addTaskDetail: `/supervision/addTaskDetail`, // 添加监装监卸信息/航行动态
  applyUnloadTask: `/supervision/applyUnloadTask`, // 申请监卸
  addGoodsRelease: `/supervision/addGoodsRelease`, // 添加放货指令
  // 资金
  queryOrderInfoCost: `/order/queryOrderInfoCost`, // 查询费用
  createOrderCost: `/order/createOrderCost`, // 创建费用
  getCostBatchNi: `/order/getCostBatchNi`, // 获取费用编号
  deleteOrderInfoCost: `/order/deleteOrderInfoCost`, // 删除费用
  queryCustInsuranceListSelect: `/common/queryCustInsuranceListSelect`, // 查询保险公司列表选择框
  queryCustListSelect: `/common/queryCustListSelect`, // 查询结算对象
  queryFeetype: `/common/queryFeetype`, // 查询费用类型
  // 发票
  queryOrderInvoice: `/order/queryOrderInvoice`, // 查询发票
  queryOrderShipTrajectoryInfo: `/order/queryOrderShipTrajectoryInfo`, // 查询订单轨迹信息

  queryContractBaseOrderInfo: `/order/queryContractBaseOrderInfo`,

  // 2.1.1 更新轨迹
  changeOrderTrack: `/order/setShipCXW`,
}
export default requestApi

export const queryUserListSelect = (data) => api(requestApi.queryUserListSelect, data)
export const queryOrderList = (data) => api(requestApi.queryOrderList, data)
export const queryShipListSelect = (data) => api(requestApi.queryShipListSelect, data)
export const queryShipOwnerListSelect = (data) => api(requestApi.queryShipOwnerListSelect, data)
export const queryCargoOwnerListSelect = (data) => api(requestApi.queryCargoOwnerListSelect, data)
export const queryGoodsData = (data) => api(requestApi.queryGoodsData, data)
export const getHCBatchNo = (data) => api(requestApi.getHCBatchNo, data)
export const createOrder = (data) => api(requestApi.createOrder, data)

export const queryOrderInfo = (data) => api(requestApi.queryOrderInfo, data)
export const changeOrderStatus = (data) => api(requestApi.changeOrderStatus, data)
export const updateStatusChange = (data) => api(requestApi.updateStatusChange, data)
export const queryOrderInfoContract = (data) => api(requestApi.queryOrderInfoContract, data)
export const saveOrderInfoContract = (data) => api(requestApi.saveOrderInfoContract, data)

export const getOrderSupervisionInfo = (data) => api(requestApi.getOrderSupervisionInfo, data)
export const getGoodsReleaseDetail = (data) => api(requestApi.getGoodsReleaseDetail, data)
export const applyLoadTask = (data) => api(requestApi.applyLoadTask, data)
export const addGoodsDetail = (data) => api(requestApi.addGoodsDetail, data)
export const addTaskDetail = (data) => api(requestApi.addTaskDetail, data)
export const applyUnloadTask = (data) => api(requestApi.applyUnloadTask, data)
export const addGoodsRelease = (data) => api(requestApi.addGoodsRelease, data)

export const queryOrderInfoCost = (data) => api(requestApi.queryOrderInfoCost, data)
export const createOrderCost = (data) => api(requestApi.createOrderCost, data)
export const getCostBatchNi = (data) => api(requestApi.getCostBatchNi, data)
export const deleteOrderInfoCost = (data) => api(requestApi.deleteOrderInfoCost, data)
export const queryCustInsuranceListSelect = (data) => api(requestApi.queryCustInsuranceListSelect, data)
export const queryCustListSelect = (data) => api(requestApi.queryCustListSelect, data)
export const queryFeetype = (data) => api(requestApi.queryFeetype, data)

export const queryOrderInvoice = (data) => api(requestApi.queryOrderInvoice, data)
export const queryOrderShipTrajectoryInfo = (data) => api(requestApi.queryOrderShipTrajectoryInfo, data)

export const queryContractBaseOrderInfo = (data) => api(requestApi.queryContractBaseOrderInfo, data)
export const changeOrderTrack = (data) => api(requestApi.changeOrderTrack, data)



// WEBPACK FOOTER //
// ./src/api/orderCenter.js